module.exports = __webpack_public_path__ + "static/media/complete.cb495180.svg";